import React from 'react';

import {
  FlexProps,
  Flex,
  Text,
} from '@chakra-ui/react';

interface AddressInfoProps extends FlexProps {
  address: any
}

export default function AddressInfo({ address = { }, ...rest }: AddressInfoProps) {
  if (!address) {
    return <Flex {...rest} />;
  }

  return (
    <Flex
      flexDir="column"
      {...rest}>
      <Text
        variant="xSmallRegular"
        color="gray.500">
        {`${address?.street}, ${address?.number} ${address?.complement || ''} - ${address?.district}`}
      </Text>
      <Text
        variant="xSmallRegular"
        color="gray.500">
        {`CEP: ${address?.postalCode}, ${address?.city || ''} - ${address?.state || ''}`}
      </Text>
    </Flex>
  );
}
